module.exports = __webpack_public_path__ + "static/Xbanners-1a6926a9a2d747643040cd69b9ca1599.png";